import React from 'react';
import {
    EyeOutlined,
    PlusOutlined,
    ReloadOutlined,
    DownloadOutlined,
    UndoOutlined,
    MenuOutlined,
    LeftOutlined,
    RightOutlined,
    CheckOutlined
} from "@ant-design/icons";
import LogoutIcon from '@mui/icons-material/Logout';
import { Logout } from '@mui/icons-material';

export const CustomIcons = {
    Add: <PlusOutlined />,
    View: <EyeOutlined />,
    Update: <ReloadOutlined /> ,
    Download: <DownloadOutlined />,
    Clear: <UndoOutlined />,
    Menu: <MenuOutlined/>,
    LeftArrow: <LeftOutlined />,
    RightArrow: <RightOutlined />,
    Verify: <CheckOutlined />,
    Logout: <LogoutIcon />,
};
